import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { ArrowBack, Menu } from "@material-ui/icons";
import { Button, Drawer, Select, MenuItem } from "@material-ui/core";
import { number } from "../../../utils";

import kwh_icon from "../../../assets/Icons/kwh-01-yellow.png";
import kw_icon from "../../../assets/Icons/kw-01-yellow.png";
import temp_icon from "../../../assets/Icons/temp-01-yellow.png";

import styles from "./styles.scss";

@CSSModules(styles, { allowMultiple: true })
class Header extends Component {
	componentDidMount() {
        this.props.startComponent();
    }

    componentWillUnmount(){
        this.props.stopComponent();
    }

   render() {
      const { route } = this.props;
      return (
         <div styleName="container">
            {this.props.dailyUsage !== undefined && this.props.dailyUsage !== null && (
               <div styleName="item-wrap">
                  <img src={kwh_icon} styleName="icon" alt="" />
                  <p styleName="item-text">{number.parseNumber(this.props.dailyUsage, 0)} kWh</p>
               </div>
            )}
            {this.props.currentUsage !== undefined && this.props.currentUsage !== null && (
               <div styleName="item-wrap">
                  <img src={kw_icon} styleName="icon" alt="" />
                  <p styleName="item-text">{number.parseNumber(this.props.currentUsage, 0)} kW</p>
               </div>
            )}
            {this.props.currentTemp !== undefined && this.props.currentTemp !== null && (
               <div styleName="item-wrap">
                  <img src={temp_icon} styleName="icon" alt="" />
                  <p styleName="item-text">{number.parseNumber(this.props.currentTemp, 1)} &deg;C</p>
               </div>
            )}
         </div>
      );
   }
}

const bindAction = dispatch => {
   return {
      startComponent: () => dispatch(actions.startComponent()),
      stopComponent: () => dispatch(actions.stopComponent()),
   };
};

const mapStateToProps = state => ({
   dailyUsage: state.rtMenuDataRedux.dailyUsage,
   currentUsage: state.rtMenuDataRedux.currentUsage,
   currentTemp: state.rtMenuDataRedux.currentTemp,
   
});

export default connect(
   mapStateToProps,
   bindAction
)(Header);



// WEBPACK FOOTER //
// ./src/components/Realtime/MenuData/MenuData.js